var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMentor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "mentor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 18,
    r: 3,
    fill: "#8ae5d0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ae5d0",
    d: "M9,21a6,6,0,0,0-5.89,4.848A.993.993,0,0,0,4.1,27h9.8a.993.993,0,0,0,.992-1.152A6,6,0,0,0,9,21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 18,
    r: 3,
    fill: "#8ae5d0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ae5d0",
    d: "M28.89 25.848a6 6 0 00-11.78 0A.993.993 0 0018.1 27h9.8A.993.993 0 0028.89 25.848zM19 11a1 1 0 001-1V6a1 1 0 00-1-1H13a1 1 0 00-1 1v6l2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f363a",
    d: "M11.948 20.681a4 4 0 10-5.9 0 6.978 6.978 0 00-3.923 4.976 1.941 1.941 0 00.412 1.606A2.019 2.019 0 004.1 28h9.8a2.019 2.019 0 001.561-.737 1.94 1.94 0 00.412-1.605A6.977 6.977 0 0011.948 20.681zM9 16a2 2 0 11-2 2A2 2 0 019 16zM4.1 26a5 5 0 019.8 0zM29.871 25.658a6.977 6.977 0 00-3.923-4.977 4 4 0 10-5.9 0 6.978 6.978 0 00-3.923 4.976 1.941 1.941 0 00.412 1.606A2.019 2.019 0 0018.1 28h9.8a2.019 2.019 0 001.561-.737A1.94 1.94 0 0029.871 25.658zM23 16a2 2 0 11-2 2A2 2 0 0123 16zM18.1 26A5 5 0 0127.9 26zM11.475 12.851a1 1 0 00.972.044L14.236 12H19a2 2 0 002-2V6a2 2 0 00-2-2H13a2 2 0 00-2 2v6A1 1 0 0011.475 12.851zM13 6h6l0 4H14a1 1 0 00-.447.105L13 10.382z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentor);
export default __webpack_public_path__ + "static/media/mentor.39d1db8d9df1e8a10575e1ac30017810.svg";
export { ForwardRef as ReactComponent };